import { createContext } from 'react';

const throwContextError = () => {
    throw new Error('Must be used inside <LogtoProvider> context.');
};
/**
 * The context for the LogtoProvider.
 *
 * @remarks
 * Instead of using this context directly, in most cases you should use the `useLogto` hook.
 */
const LogtoContext = createContext({
    logtoClient: undefined,
    isAuthenticated: false,
    isLoading: false,
    error: undefined,
    setIsAuthenticated: throwContextError,
    setIsLoading: throwContextError,
    setError: throwContextError,
});

export { LogtoContext, throwContextError };
